export default "__VITE_ASSET__2f2c015c__"